import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle0601 from "./layouts/principle-06/principle-06-01";
import principle0602 from "./layouts/principle-06/principle-06-02";
import principle0603 from "./layouts/principle-06/principle-06-03";
import principle0604 from "./layouts/principle-06/principle-06-04";
import principle0605 from "./layouts/principle-06/principle-06-05";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "74078c07-143c-49a4-a2ea-80042d7e4e19",
  publicId: "26",
  name: "Sound system quality evaluation testing ",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [
    principle01,
    principle02,
    principle03,
    principle04,
    principle05,
    principle0601,
    principle0602,
    principle0603,
    principle0604,
    principle0605,
    task01,
    task02,
  ],
};

export default lesson;
